/*
 * This file is part of Mitei Server.
 * Copyright (c) 2019 f0reachARR <f0reach@f0reach.me>
 *
 * Mitei Server is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * Mitei Server is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Mitei Server.  If not, see <http://www.gnu.org/licenses/>.
 */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
const messageDialogContext = React.createContext({
    isOpen: false,
    title: '',
    messages: [],
    open: _param => { },
    close: () => { },
});
export const MessageDialogContextProvider = ({ children }) => {
    const [open, setOpen] = React.useState(false);
    const [messages, setMessages] = React.useState([]);
    const [title, setTitle] = React.useState('');
    const contextValue = React.useMemo(() => ({
        isOpen: open,
        open: (title, ...err) => {
            setTitle(title);
            setMessages(err);
            setOpen(true);
        },
        close: () => setOpen(false),
        messages,
        title,
    }), [open, messages, title]);
    return (React.createElement(messageDialogContext.Provider, { value: contextValue }, children));
};
export const useMessageDialog = () => {
    const contextValue = React.useContext(messageDialogContext);
    return contextValue.open;
};
export const MessageDialogView = () => {
    const contextValue = React.useContext(messageDialogContext);
    const handleClose = () => {
        contextValue.close();
    };
    return (React.createElement(Dialog, { open: contextValue.isOpen, onClose: handleClose, fullWidth: true },
        React.createElement(DialogTitle, null, contextValue.title),
        React.createElement(DialogContent, null, contextValue.messages.map((text, i) => (React.createElement(Typography, { key: i }, text)))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: handleClose }, "\u9589\u3058\u308B"))));
};
//# sourceMappingURL=index.js.map